import styled from 'styled-components';

export const PressureFieldsContainer = styled.div`
  display: flex;
  gap: 20px;
`;
